import { Component, Output, EventEmitter, ElementRef } from '@angular/core';
import { Session } from '../services/session';
import { EnterpriseProductivityFeatureFlagService } from '@services/feature-flags/enterprise-productivity';
import { SettingsAccount } from '../settings/account.service';
import { DEFAULT_TIME_ZONE } from '../lib/time-zones';
import { II18nBackendStrings, TimeZones as i18nTimeZones } from '../lib/i18n-backend-strings';

@Component({
  providers: [SettingsAccount],
  selector: 'time-zone-banner',
  templateUrl: './time-zone-banner.component.html',
})
export class TimeZoneBannerComponent {
  @Output() public onBannerClose = new EventEmitter();
  @Output() public onBannerOpen = new EventEmitter();
  public defaultTimeZone: string;
  public readonly i18nTimeZones: II18nBackendStrings = i18nTimeZones;
  public readonly isGlobalTimezonesEnabled: boolean;
  public standardTimeZones: string;
  private bannerClosedEmitCalled = false;

  constructor(
    private el: ElementRef,
    private session: Session,
    private settings: SettingsAccount,
    epFeatureFlag: EnterpriseProductivityFeatureFlagService,
  ) {
    this.defaultTimeZone = DEFAULT_TIME_ZONE;
    this.isGlobalTimezonesEnabled = epFeatureFlag.isGlobalTimezonesEnabled();
    this.standardTimeZones = this.session.getStandardTimeZone(this.defaultTimeZone);
    const hasTimeZone = !!this.session.getUser().time_zone;
    if (hasTimeZone) {
      this.bannerClosedEmitCalled = true;
      this.el.nativeElement.classList.add('hide');
    } else this.onBannerOpen.emit();
  }

  get hasNoTimeZone() {
    const hasNoTimeZone = !this.session.getUser().time_zone;
    if (!hasNoTimeZone && !this.bannerClosedEmitCalled) {
      this.bannerClosedEmitCalled = true;
      this.el.nativeElement.classList.add('hide');
      this.onBannerClose.emit();
    }
    return hasNoTimeZone;
  }

  public saveDefaultTimeZone() {
    (this.settings as any)
      .save({ time_zone: this.defaultTimeZone })
      .subscribe(() => this.session.refresh())
    ;
  }
}
